import { isImage, isVideo, isDocument } from 'utilities/file';

import CustomerReferralsAndRewards from './customer-referrals-and-rewards';

class StartupCustomers {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/customers`;
    this.baseCustomerPath = `${this.basePath}/:startupCustomerId`;
    this.apiClient = apiClient;

    this.referralsAndRewards = new CustomerReferralsAndRewards(this.baseCustomerPath, this.apiClient);

  }

  async bootstrap(query, urlParameters) {

    const path = `${this.basePath}/bootstrap`;

    return this.apiClient.post(path, {}, {}, { query, urlParameters });

  }

  createCustomerForEmailAddress(data) {

    const path = this.basePath;

    return this.apiClient.post(path, {}, {}, data);

  }

  async getPaginatedCustomersByQueryOptions(queryOptions) {

    const path = this.basePath;

    return this.apiClient.get(path, {}, queryOptions);

  }

  async searchCustomers(searchTerm) {

    const path = `${this.basePath}/search`;

    return this.apiClient.post(path, {}, {}, { searchTerm });

  }

  async getStartupUserBasicProfileById(startupCustomerId) {

    const path = this.baseCustomerPath + '/basic-profile';

    return this.apiClient.get(path, {
      startupCustomerId
    });

  }

  async updateStartupUserBasicProfileById(startupCustomerId, profile) {

    const path = this.baseCustomerPath + '/basic-profile';

    return this.apiClient.put(path, { startupCustomerId }, {}, profile);

  }

  async updateStartupUserProfilePictureById(startupCustomerId, file) {

    const path = this.baseCustomerPath + '/profile-picture';

    const data = new FormData();
    data.append('file', file);

    return this.apiClient.put(path, { startupCustomerId }, {}, data, true);

  }

  async updateStartupUserUsernameById(startupCustomerId, data) {

    const path = this.baseCustomerPath + '/username';

    return this.apiClient.put(path, { startupCustomerId }, {}, data);

  }

  async updateStartupUserEmailAddressById(startupCustomerId, data) {

    const path = this.baseCustomerPath + '/email';

    return this.apiClient.put(path, { startupCustomerId }, {}, data);

  }

  async updateStartupUserSocialHandleById(startupCustomerId, data) {

    const path = this.baseCustomerPath + '/social-handle';

    return this.apiClient.put(path, { startupCustomerId }, {}, data);

  }

  async updateStartupUserPhoneNumberById(startupCustomerId, data) {

    const path = this.baseCustomerPath + '/phone-number';

    return this.apiClient.put(path, { startupCustomerId }, {}, data);

  }

  async getUserMetaInformationByStartupUserId(startupCustomerId) {

    const path = `${this.baseCustomerPath}/observations/metadata`;

    return this.apiClient.get(path, { startupCustomerId }, {});

  }

  async createStartupUserProperty(startupCustomerId, data) {

    const path = `${this.baseCustomerPath}/observations/metadata`;

    return this.apiClient.post(path, { startupCustomerId }, {}, data);

  }

  async updateStartupUserPropertyByIdAndStartupUserId(startupCustomerId, name, data) {

    const path = `${this.baseCustomerPath}/observations/metadata/:name`;

    return this.apiClient.put(path, { startupCustomerId, name }, {}, data);

  }

  async deleteStartupUserPropertyByIdAndStartupUserId(startupCustomerId, propertyId) {

    const path = `${this.baseCustomerPath}/observations/metadata/:propertyId`;

    return this.apiClient.delete(path, { startupCustomerId, propertyId }, {});

  }

  async getSessionsByStartupUserIdAndQueryOptions(startupCustomerId, queryOptions) {

    const path = `${this.baseCustomerPath}/observations/sessions`;

    return this.apiClient.get(path, { startupCustomerId }, queryOptions);

  }

  async getPageEventsByStartupUserIdAndSessionId(startupCustomerId, sessionId, paginationOptions) {

    const path = `${this.baseCustomerPath}/observations/sessions/:sessionId`;

    return this.apiClient.get(path, { startupCustomerId, sessionId }, { paginationOptions });

  }

  async getUserSessionRecordingsByStartupUserId(startupCustomerId, paginationOptions, projection) {

    const path = `${this.baseCustomerPath}/observations/recordings`;

    return this.apiClient.get(path, { startupCustomerId }, { paginationOptions, projection });

  }

  async getViewRecordingByStartupUserIdPageSessionIdAndSessionId(startupCustomerId, pageSessionId, sessionId, skip, limit) {

    const path = `${this.baseCustomerPath}/observations/sessions/:sessionId/pages/:pageSessionId/recording`;

    return this.apiClient.get(path, { startupCustomerId, pageSessionId, sessionId }, { paginationOptions: { skip, limit } });

  }

  async getStartupUserActivities(startupCustomerId, queryOptions) {

    const path = `${this.baseCustomerPath}/observations/activities`;

    return this.apiClient.get(path, { startupCustomerId }, queryOptions);

  }

  async getCustomerConversationsForBrowserClient(startupCustomerId, queryOptions) {

    const path = `${this.baseCustomerPath}/conversations`;

    return this.apiClient.get(path, { startupCustomerId }, queryOptions);

  }

  async getActivePlanForUser(startupCustomerId) {

    const path = `${this.baseCustomerPath}/plan`;

    return this.apiClient.get(path, { startupCustomerId }, {});

  }

  async getStartupUserBillingPortalURLById(startupCustomerId, data) {

    const path = `${this.baseCustomerPath}/billing-portal`;

    return this.apiClient.post(path, { startupCustomerId }, {}, data);

  }

  async setUserPlanMetricExtraCount(startupCustomerId, metricName, data) {

    const path = `${this.baseCustomerPath}/metrics/:metricName/extra-count`;

    return this.apiClient.put(path, { startupCustomerId, metricName }, {}, data);

  }

  async hideStartupUsersByIds(startupCustomerIds) {

    const path = `${this.basePath}/hide-many`;

    return this.apiClient.put(path, {}, {}, startupCustomerIds);

  }

  async unhideStartupUsersByIds(startupCustomerIds) {

    const path = `${this.basePath}/unhide-many`;

    return this.apiClient.put(path, {}, {}, startupCustomerIds);

  }

  async deleteStartupCustomerById(startupCustomerId) {

    const path = `${this.baseCustomerPath}`;

    return this.apiClient.delete(path, { startupCustomerId });

  }

  async hideStartupUserById(startupCustomerId) {

    const path = `${this.baseCustomerPath}/hide`;

    return this.apiClient.put(path, { startupCustomerId });

  }

  async unhideStartupUserById(startupCustomerId) {

    const path = `${this.baseCustomerPath}/unhide`;

    return this.apiClient.put(path, { startupCustomerId });

  }

  async getNoteByStartupUserId(startupCustomerId) {

    const path = `${this.baseCustomerPath}/note`;

    return this.apiClient.get(path, { startupCustomerId }, {});

  }

  async updateNoteByStartupUserId(startupCustomerId, data) {

    const path = `${this.baseCustomerPath}/note`;

    return this.apiClient.put(path, { startupCustomerId }, {}, data);

  }

  async uploadFileForNote(startupCustomerId, file) {

    let path = `${this.baseCustomerPath}/note`;

    if (isImage(file)) {
      path = `${path}/images`;
    } else if (isVideo(file)) {
      path = `${path}/videos`;
    } else if (isDocument(file)) {
      path = `${path}/documents`;
    }

    const data = new FormData();
    data.append('file', file);

    return this.apiClient.post(path, { startupCustomerId }, {}, data, true, false);

  }

  async blockCustomers(customerIds) {

    const path = `${this.basePath}/blocked`;

    return this.apiClient.post(path, {}, {}, customerIds);

  }

  async unblockCustomer(customerId) {

    const path = `${this.basePath}/:customerId/block`;

    return this.apiClient.delete(path, { customerId });

  }

  async getBlockedCustomers(queryOptions) {

    const path = `${this.basePath}/blocked`;

    return this.apiClient.get(path, {}, queryOptions);

  }

  async getRegisteredCustomersByQueryOptions(queryOptions) {

    const path = `${this.basePath}/registered`;

    return this.apiClient.get(path, {}, queryOptions);

  }

  async blockCustomerAndIP(customerId) {

    const path = `${this.basePath}/:customerId/block-with-ip`;

    return this.apiClient.post(path, { customerId }, {}, {});

  }

  async unblockCustomerAndIP(customerId) {

    const path = `${this.basePath}/:customerId/unblock-with-ip`;

    return this.apiClient.delete(path, { customerId });

  }

}

export default StartupCustomers;